import { Component } from '@angular/core';
import {MarkdownComponent, provideMarkdown} from 'ngx-markdown';

@Component({
  selector: 'app-introduction-changelog',
  imports: [
    MarkdownComponent
  ],
  templateUrl: './introduction-changelog.component.html',
  styleUrl: './introduction-changelog.component.scss',
  providers: [
    provideMarkdown(),
  ],
})
export class IntroductionChangelogComponent {

}
